import { postLog } from './log';
import { uuid } from './uuid';

export function isProdDomain(config) {
  return (
    config.domain == 'www.seattleaquarium.org'
    || config.domain == 'seattleaquarium.org'
    || config.domain == 'seaaquariumweb.wpenginepowered.com'
  );
}

export function getCheckoutURL(config) {
  return isProdDomain(config)
    ? '/_r4p/v2/b2c/cors/checkout' // prod
    : '/_r4s/v2/b2c/cors/checkout'; // dev
}

export function getPubKey(config) {
  return isProdDomain(config)
    ? '6b6f862a-657f-489d-af56-6ac1370693e2' // prod
    : '2b08e6d7-e38a-4f32-8c4c-709a4332266c'; // sandbox
}

export async function postCheckout(config, token, cart) {
  const checkoutUUID = uuid();

  const response = await fetch(getCheckoutURL(config), {
    method: 'POST',
    headers: {
      "Content-Type": "application/json",
      "x-acme-pub-api-key": getPubKey(config),
      "x-b2c-tenant-id": '318',
      "x-acme-request-uuid": checkoutUUID,
      "x-acme-captcha-token": token
    },
    body: JSON.stringify(cart)
  });

  return response;
}
